module.exports = __webpack_public_path__ + "img/discovery.5cca5d84.png";